import { formatAmplienceImageURL } from "@JohnLewisPartnership/jl-design-system/dist/utils/imageUrlModifier/imageUrlModifier";

const profiles = [`?wid=320&hei=426 320w`, `?wid=640&hei=853 640w`];

export const imageProfileGenerator = (imageUrl: string) => {
  if (!imageUrl) return "";

  return profiles
    .map((profile) => formatAmplienceImageURL(`${imageUrl}${profile}`))
    .join();
};
